export const BRAND_ASSET_VERSION = '2026-04-18-transparent-v2';
export const BRAND_LOGO_FULL_SRC = `/brand/logo-full.png?v=${BRAND_ASSET_VERSION}`;
